export default __webpack_public_path__ + "static/media/jackpot-cn.926005ca.webp";